angular
  .module('contrast.factory.alert', [])
  .factory('AlertFactory', function ($http, UserService) {
    return {
      getAlerts: function () {
        return $http.get(UserService.buildAPIUrl('/alerts'))
      },
      getAlertsAttack: function () {
        return $http.get(UserService.buildAPIUrl('/alerts/attack'))
      },
      getAlertAttackTriggers: function () {
        return $http.get(UserService.buildAPIUrl('/alerts/attack/triggers'))
      },
      updateAlertStatus: function (id) {
        return $http.put(UserService.buildAPIUrl('/alerts/' + id + '/status'))
      },
      updateAlertAttackStatus: function (uuid) {
        return $http.put(
          UserService.buildAPIUrl('/alerts/attack/' + uuid + '/status')
        )
      },
      deleteAlert: function (id) {
        return $http['delete'](UserService.buildAPIUrl('/alerts/' + id))
      },
      deleteAlertAttack: function (uuid) {
        return $http['delete'](
          UserService.buildAPIUrl('/alerts/attack/' + uuid)
        )
      },
      addAlert: function (data) {
        return $http.post(UserService.buildAPIUrl('/alerts'), data)
      },
      addAlertAttack: function (data) {
        return $http.post(UserService.buildAPIUrl('/alerts/attack'), data)
      },
      editAlert: function (id, data) {
        return $http.put(UserService.buildAPIUrl('/alerts/' + id), data)
      },
      editAlertAttack: function (uuid, data) {
        return $http.put(
          UserService.buildAPIUrl('/alerts/attack/' + uuid),
          data
        )
      }
    }
  })
